export default {
  Regular: 1,
  ApiKey: 2,
  Global: 3,
};
